export const MerchantSuccessFooterMessages = {
  title: {
    id: 'Pages.MerchantSelectSuccess.MerchantView.Footer.title',
    description: 'Contact Details',
  },
}
